// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReactGa4 from "react-ga4";

function publishGaEvent(payload) {
  ReactGa4.default.event(payload);
  
}

function publishGaPageview(payload) {
  ReactGa4.default.send(payload.hitType, payload.page);
  
}

export {
  publishGaEvent ,
  publishGaPageview ,
  
}
/* react-ga4 Not a pure module */
